import { State } from "../types";
import React from "react";
export default class SelectedVenueDetailsHelper {
  /**
   * Get the selected venue details based on user selected venue from previous pages
   * @param state - The state object containing the relevent details
   * @returns An object containing the name, location and url of the selected venue
   */
  static getVenueDetails = (state: State) => {
    if (state.isCrossSellChosen) {
      const venue = state.crossSellSetup?.CrossSellVenues.find(
        (csv) =>
          csv.MicrositeName === state.bookingDetails.timeSlot?.MicrositeName
      );
      return {
        name: venue?.Name,
        location: venue?.Address,
        url: `https://www.google.com/maps/search/?api=1&query=${venue?.Name},${venue?.Address}`,
        micrositeName: venue?.MicrositeName,
      };
    }
    return {
      name: state.crossSellSetup?.Name,
      location: state.crossSellSetup?.FullAddress,
      url: `https://www.google.com/maps/search/?api=1&query=${state.crossSellSetup?.Name},${state.crossSellSetup?.FullAddress}`,
      micrositeName: state.micrositeName,
    };
  };

  /**
   * Format the full address into lines separated by <br /> tags
   * @param fullAddress - The full address string to format
   * @returns A ReactNode array containing the formatted address lines
   */
  static formatVenueAddressIntoLines(fullAddress: string): React.ReactNode {
    const addressLines = fullAddress.split(", ");
    const formattedAddress: React.ReactNode[] = [];

    addressLines.forEach((line, index) => {
      formattedAddress.push(line);
      if (index < addressLines.length - 1) {
        formattedAddress.push(
          React.createElement("br", { key: `br-${index}` })
        );
      }
    });

    return formattedAddress;
  }
}
